import { render, staticRenderFns } from "./GroupProjectGates.vue?vue&type=template&id=510e5cea&scoped=true"
import script from "./GroupProjectGates.vue?vue&type=script&lang=js"
export * from "./GroupProjectGates.vue?vue&type=script&lang=js"
import style0 from "./GroupProjectGates.vue?vue&type=style&index=0&id=510e5cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e5cea",
  null
  
)

export default component.exports